module.exports = __webpack_public_path__ + "static/media/mainReport.ee42da5d.png";